import type { ActivityFacts } from '../api/types.js';

// How the review facts of a person read on their page and their sheet (ADR-030)

/** The directories they merged in most, for a line under the repository */
export function topDirs(f: ActivityFacts, n = 3): string {
  return Object.entries(f.dirs ?? {}).sort(([, a], [, b]) => b - a).slice(0, n).map(([d]) => `${d}/`).join(', ');
}

/** Merged, and how many of those went through without changes asked, when the reviews were read */
export function mergedLabel(f: { merged: number; alone?: number }): string {
  return f.alone !== undefined && f.merged ? `${f.merged} (${f.alone} alone)` : String(f.merged);
}

export const ALONE_HINT = 'In parentheses: merged without anyone asking for changes';
